import React from "react";

import { useTheme } from "../../../context/theme";
import { Box, Inline } from "../../layout";
import ContextPopup from "../components/ContextPopup";
import ContextMenu from "../components/ContextPopup/components/ContextMenu";
import PopupArrow from "../components/PopupArrow";
import { Position } from "../types";

type Props = {
  children: {
    label: React.ReactNode;
    options: React.ReactNode;
  };
  position: Position;
  loading?: boolean;
  ariaLabel?: string;
};

export default function TextHoverMenu({
  children,
  position = "bottom",
  loading,
  ariaLabel = "Options"
}: Props) {
  const theme = useTheme();

  return (
    <ContextPopup position={position} hover>
      {{
        anchor: ({ anchorProps }) => (
          <Box
            component="button"
            {...anchorProps}
            aria-label={ariaLabel}
            className="focus-malibu"
            cursor="pointer"
            border="none"
            outline="none"
            backgroundColor="transparent"
            width="fit-content"
            padding="none"
          >
            {loading || (
              <Inline alignItems="center" space="large">
                {children.label}
                <Box
                  borderColor={`${theme["neutral-high-content"]} transparent transparent transparent`}
                  borderBottomWidth="none"
                  borderWidth="medium"
                  borderStyle="solid"
                />
              </Inline>
            )}
          </Box>
        ),
        popup: () => (
          <Box
            display="flex"
            alignItems="center"
            position="relative"
            dataTest="TextHoverMenuOptions"
          >
            <ContextMenu position={position}>{children.options}</ContextMenu>
            <PopupArrow position={position} />
          </Box>
        )
      }}
    </ContextPopup>
  );
}
